import type { IndustryRecent } from "@/lib/types/industry";

const IMPACT_META = {
  positive: { icon: "📈", color: "text-emerald-400" },
  negative: { icon: "📉", color: "text-rose-400" },
  neutral:  { icon: "○",  color: "text-slate-400" },
} as const;

function safeHostname(url: string): string | null {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

export function IndustryRecentEvents({ recent }: { recent: IndustryRecent }) {
  return (
    <div className="space-y-3">
      <p className="text-sm leading-relaxed text-slate-200">{recent.summary}</p>

      {recent.events.length === 0 ? (
        <p className="text-xs text-slate-500">No notable events in the last 60 days.</p>
      ) : (
        <ul className="space-y-2">
          {recent.events.map((e, i) => {
            const meta = IMPACT_META[e.impact] ?? IMPACT_META.neutral;
            return (
              <li key={`${e.headline}-${i}`} className="rounded border border-slate-700 bg-slate-900 p-3">
                <div className="mb-1 flex items-center gap-2 text-xs">
                  <span className={meta.color}>{meta.icon}</span>
                  <span className="font-medium text-slate-100">{e.headline}</span>
                  <span className="text-slate-500">·</span>
                  <time dateTime={e.date} className="text-slate-500">{e.date}</time>
                </div>
                <p className="text-xs leading-relaxed text-slate-300">{e.detail}</p>
                {e.sourceUrl && (
                  <a
                    href={e.sourceUrl}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="mt-1 inline-block text-[11px] text-slate-500 hover:text-slate-300"
                  >
                    Source: {e.sourceName || safeHostname(e.sourceUrl) || "link"} ↗
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
